import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=fe199a58&scoped=true"
import script from "./InfoBanner.vue?vue&type=script&lang=js"
export * from "./InfoBanner.vue?vue&type=script&lang=js"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=fe199a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe199a58",
  null
  
)

export default component.exports